<template>
    <div>
        <b-button v-b-tooltip.hover title="Configuración de borders"
            variant="none" class="p-0" @click="onHandleOPenBorderOptions">
            <i class="fa fa-square-o" :style="{ fontSize: '25px' }"></i>
        </b-button>
        <b-toast id="show-options-border" title="Opciones de borde" static no-auto-hide
            class="position-absolute p-2 bg-white"
            :style="{ zIndex: 10, boxShadow: '#c4c4c4 0px 0px 18px -3px' }">
            <b-row>
                <b-col cols="12">
                    <strong>Posición</strong>
                    <div class="d-flex align-items-center align-items-start flex-wrap">
                        <b-form-checkbox v-for="option in border.positions" button button-variant="light"
                            v-model="borderPositions"
                            :key="option.value" :value="option.value"
                            class="m-1">
                            <div :style="option.preview"></div>
                        </b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-2">
                    <strong>Ancho</strong>
                    <el-select v-model="activeSection.borderWidth" name="border_width">
                        <el-option class="d-flex align-items-center align-items-start"
                            v-for="x in border.widths" :key="x.value" :label="x.value" :value="x.value">
                            <div :style="x.preview"></div>
                            <span class="ml-2">{{ x.label }}</span>
                        </el-option>
                    </el-select>
                </b-col>
                <b-col cols="12" class="mt-1">
                    <strong>Estilo</strong>
                    <el-select v-model="activeSection.borderStyle" name="border_style">
                        <el-option class="d-flex align-items-center align-items-start"
                            v-for="x in border.styles" :key="x.value" :label="x.value" :value="x.value">
                            <div :style="x.preview"></div>
                            <span class="ml-2">{{ x.label }}</span>
                        </el-option>
                    </el-select>
                </b-col>
                <b-col cols="12" class="mt-1">
                    <strong>Color</strong>
                    <b-form-input v-model="activeSection.borderColor" type="color" name="border_color"
                        size="sm"></b-form-input>
                </b-col>
                <b-col cols="12">
                    <b-button variant="dark" class="p-1 mt-2 text-white" size="sm" block
                        @click="$bvToast.hide('show-options-border')">
                        cerrar <i class="fa fa-check ml-1"></i>
                    </b-button>
                </b-col>
            </b-row>
        </b-toast>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'BorderSettings',
    
    data() {
        return {
            borderPositions: []
        }
    },

    watch: {
        borderPositions(next) {
            if (next && typeof next === 'object') this.setActiveSectionBorderPositions(next)
        }
    },
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'border'
        ])
    },

    methods: {
        ...mapMutations('labelDesigner', [
            'setActiveSectionBorderPositions'
        ]),

        onHandleOPenBorderOptions() {
            let currentPositions = []
            if (this.activeSection && this.activeSection.borderPositions && typeof this.activeSection.borderPositions === 'object') {
                currentPositions = this.activeSection.borderPositions
            }

            this.setActiveSectionBorderPositions(currentPositions)
            this.borderPositions = currentPositions

            this.$bvToast.show('show-options-border')
        }
    }
}
</script> 